import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DevicesComponent } from './devices/devices.component';
import { ProtectedComponent } from './protected/protected.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NoPermissionComponent } from './no-permission/no-permission.component';
import { HierarchiesComponent } from './hierarchies/hierarchies.component';
import { LoadComponent } from './load/load.component';
import { RedirectGuard } from './core/redirect-guard';
import { AuthGuard } from './core/auth/auth.guard';
import { LoginComponent } from './login/login.component';
import { CallbackComponent } from './callback/callback.component';
import { MessagesComponent } from "./messages/messages.component";
import { MapComponent } from './map/map.component';

const routes: Routes = [
  { path: '', redirectTo: '/protected/dashboard', pathMatch: 'full' },
  {
    path: 'login',
    canActivate: [RedirectGuard],
    component: LoginComponent,
    data: { path: 'oauth2/authorization/oxauth', redirect: 'callback' },
  },
  {
    path: 'logout',
    canActivate: [RedirectGuard],
    component: LoadComponent,
    data: { path: 'logout', redirect: 'callback' },
  },
  {
    path: 'change-password',
    canActivate: [RedirectGuard],
    component: LoadComponent,
    data: { acr: 'basic_change_pw', redirect: 'callback' },
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'protected',
    component: ProtectedComponent,
    children: [
      { path: '', redirectTo: '/protected/dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        canActivate: [AuthGuard],
        component: DashboardComponent,
      },
      {
        path: 'devices',
        canActivate: [AuthGuard],
        component: DevicesComponent,
      },
      {
        path: 'hierarchies',
        canActivate: [AuthGuard],
        component: HierarchiesComponent,
      },
      {
        path: 'messages',
        canActivate: [AuthGuard],
        component: MessagesComponent,
      },
      {
        path: 'map',
        canActivate: [AuthGuard],
        component: MapComponent,
      },
    ],
  },
  {
    path: 'grafana',
    canActivate: [AuthGuard, RedirectGuard],
    component: LoadComponent,
    data: { path: 'grafanaPath' },
  },
  { path: '404', component: PageNotFoundComponent },
  { path: 'no-permission', component: NoPermissionComponent },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // initialNavigation: 'enabledNonBlocking'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
